var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPrivacyGlass32 = function SvgPrivacyGlass32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 7.582v15.742C2 25.353 3.56 27 5.483 27h21.033C28.436 27 30 25.353 30 23.324v-8.088a2.494 2.494 0 0 0-.451-1.484 2.67 2.67 0 0 0-1.258-.968L5.168 5.114C3.598 4.609 2 5.844 2 7.583ZM8 6l-6 6m10-5L2 17m13-8L2 22m17-12L3 26m20-15L7 27m20-15L12 27m18-13L17 27m13-8-8 8",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
};
export default SvgPrivacyGlass32;